import React from 'react';

const Contact = () => {
  return(
      <>
        <div className="container-fluid wrapper">
		      <div className="container">
		      	<div className="row">
		      		<div className="col-12">
		        		<h1> Contact! </h1>
		        	</div>
		        </div>
		      </div>
	      </div>
      </>
    );
};

export default Contact;